<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Home</h4>
    </div>
    <div class="card-body">
      <div class="row"></div>
    </div>
    <div class="card-footer"></div>
  </div>

  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import { namespaceList } from "../controllers/user-contoller";
import { uploadDataChunk } from "../controllers/data-contoller";

export default {
  data: () => {
    return {
      tally: 0,
      namespace: null,
      namespaces: namespaceList,
      csv: [],
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    total() {
      return this.csv.length;
    },
    showSubmit() {
      return this.total >= 1 && this.namespace !== null;
    },
    percentage() {
      if (this.csv.length >= 1) {
        return (this.tally / this.csv.length) * 100;
      }
      return 0;
    },
  },
  methods: {
    submit() {
      this.tally = 0;
      this.uploadData(this.csv);
    },
    chunkArray(array, chunkSize) {
      return Array.from(
        { length: Math.ceil(array.length / chunkSize) },
        (_, index) => array.slice(index * chunkSize, (index + 1) * chunkSize)
      );
    },
    async uploadData(dataArray) {
      try {
        const chunks = await this.chunkArray(dataArray, 100);
        for (const chunk of chunks) {
          const processed = await uploadDataChunk(chunk, this.namespace);
          console.log(processed);
          this.tally += processed;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
